import { getApiEnvHost } from './environment';
import type { Env } from './types';

const PROTOCOL = 'https://';

const apiHosts = {
  ACE_API_BASE_HOST: `${PROTOCOL}ace-api`,
  API_BASE_HOST: `${PROTOCOL}api`,
  AVATAR_API_BASE_HOST: `${PROTOCOL}hermes`,
  BOX_API_BASE_HOST: `${PROTOCOL}box`,
  CUSTOMIZE_API_BASE_HOST: `${PROTOCOL}customize-api`,
  GROWTH_API_BASE_HOST: `${PROTOCOL}growth-api`,
  HOMEPAGE_API_BASE_HOST: `${PROTOCOL}homepage-api`,
  INVITATION_API_BASE_HOST: `${PROTOCOL}invitation-api`,
  LOCALIZATION_API_BASE_HOST: `${PROTOCOL}localization-api`,
  LOGIN_API_BASE_HOST: `${PROTOCOL}login-api`,
  NAVIGATION_API_BASE_HOST: `${PROTOCOL}universal-navigation-api`,
  NEW_MEMBER_API_BASE_HOST: `${PROTOCOL}new-member-api`,
  PAYMENT_API_BASE_HOST: `${PROTOCOL}payment`,
  QUESTIONNAIRE_API_BASE_HOST: `${PROTOCOL}questionnaire`,
  REGISTER_API_BASE_HOST: `${PROTOCOL}register-api`,
  REPLENISHMENT_API_BASE_HOST: `${PROTOCOL}replenishment-api`,
  REVENUE_API_BASE_HOST: `${PROTOCOL}revenue`,
  STOREFRONT_API_BASE_HOST: `${PROTOCOL}storefront-api`,
  USER_API_BASE_HOST: `${PROTOCOL}user`,
  CONDUCTOR_API_BASE_HOST: `${PROTOCOL}conductor`,
  ANALYTICS_API_BASE_HOST: `${PROTOCOL}analytics-api`,
  MY_ACCOUNT_API_BASE_HOST: `${PROTOCOL}my-account-api`,
  HERMES_API_BASE_HOST: `${PROTOCOL}hermes`,
  UNIVERSAL_NAVIGATION_API_BASE_HOST: `${PROTOCOL}universal-navigation-api`,
};

type ApiHosts = keyof typeof apiHosts;

/**
 * Retrieve the available API hosts for the given environment.
 * @description
 * This function takes the environment as parameter and returns
 * the API Hosts for the given environment. It also takes an
 * optional parameter to select the API Hosts to return in
 * cases where just a few are needed.
 */
export function getApiHosts(env: Env, select?: ApiHosts[]) {
  const apiEnvHost = getApiEnvHost(env);

  return Object.entries(apiHosts).reduce(
    (acc, [key, value]) => {
      const typedKey = key as ApiHosts;

      if (select && !select.includes(typedKey)) {
        return acc;
      }

      acc[typedKey] = `${value}.${apiEnvHost}`;
      return acc;
    },
    {} as Record<ApiHosts, string>,
  );
}
